module.exports = __webpack_public_path__ + "static/media/fvs_fremdlinge_49.f5e11911.jpg";